exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.input[data-v-e3bc036c]{width:100%\n}\n.marginTop[data-v-e3bc036c]{margin-top:-50px\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/screens/central/cadastros/para/solicitarInformacao/components/InformacaoDesejada.vue"],"names":[],"mappings":";AAwFA,wBACE,UAAW;CACZ;AAAA,4BAEC,gBAAiB;CAClB","file":"InformacaoDesejada.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.input {\n  width: 100%;\n}\n.marginTop {\n  margin-top: -50px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e3bc036c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/para/solicitarInformacao/components/InformacaoDesejada.vue
// module id = SNKt
// module chunks = 12